import { render, staticRenderFns } from "./CurriculumDetail.vue?vue&type=template&id=36a80c76&scoped=true&lang=pug"
import script from "./CurriculumDetail.vue?vue&type=script&lang=js"
export * from "./CurriculumDetail.vue?vue&type=script&lang=js"
import style0 from "./CurriculumDetail.vue?vue&type=style&index=0&id=36a80c76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a80c76",
  null
  
)

export default component.exports